import i18next from 'i18next';
import { SupportedLanguage } from 'src/i18n/types';

export const changeLanguage = (language: SupportedLanguage) => {
  localStorage.setItem('fdbt-dab-lng', language);
  i18next.changeLanguage(language);
};
